import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import { del } from '../../api/api';

export const deleteEmployee = (
  { employeeId, orgId, contactId }: Employee,
  options: { disableNotification?: boolean } = {},
) =>
  createGenericDispatcher({
    name: 'DELETE_EMPLOYEE',
    loadFunction: () => del(`/employee/${employeeId}`),
    args: { employeeId, orgId, contactId },
    onSuccess: (dispatch) => {
      if (!options.disableNotification) {
        dispatch(
          addNotificationAction({
            key: `delete-employee-${employeeId}`,
            message: 'Employee deleted',
          }),
        );
      }
    },
  });
